import * as scroll from './scroll';
import gsap from 'gsap';
import custom_ease from 'gsap/CustomEase';

gsap.registerPlugin(custom_ease);

custom_ease.create('smooth_ease', '0.785, 0.135, 0.15, 0.86');
custom_ease.create('normal_ease', '.165, .84, .44, 1');

/**
 * Triggers transition between pages.
 * Boolean is used to check whether its before or after type of transition.
 * @param {boolean} [after] 
 */
export function transition(after) {
  if (after) {
    gsap.fromTo(page_transition, {clipPath: 'inset(0 0 0%)'}, {
      clipPath: 'inset(100% 0 0%)',
      duration: .6,
      stagger: .2,
      ease: 'smooth_ease',
      onComplete: () => {
        scroll.disable(true);
        element();
      },
    })
  } else {
    scroll.disable();
    gsap.fromTo(page_transition, {clipPath: 'inset(0 0 100%)'}, {
      clipPath: 'inset(0 0 0%)',
      duration: .6,
      ease: 'smooth_ease',
      stagger: .2,
    })
  }
}

/**
 * Responsible for animating an element based on its attributes from duration to transparency and indexed animatin.
 * Since the website does not have fancy animations, the animation is universal, a fade-in animation.
 *  @param {HTMLElement} elm 
 *  @param {number} index 
 */
export function element(elm, index) {
  gsap.fromTo(elm, {
    y: (i, target) => {return target.dataset.animateY || '50%'},
    opacity: 0,
  }, {
    y: '0%',
    ease: 'normal_ease',
    duration: (i, target) => {return target.dataset.animateDuration || .6},
    opacity: (i, target) => {
      if (target.tagName == 'P') {
        return .9
      }
      return target.dataset.animateOpacity || 1
    },
    delay: (i, target) => {
      if (target.dataset.animateStagger == '' && index > 0) {
        return ((index + 1) * .2)
      }
      return 0
    }
  })
}